import React, { useState } from 'react';
import { UserPlusIcon, LogInIcon, KeyRoundIcon, MailIcon, LockIcon, InfoIcon } from 'lucide-react';
export function MembershipBlock() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  return <section className="w-full py-14 md:py-18" style={{
    backgroundColor: '#1e3d2f'
  }} aria-label="Membership" data-id="element-352">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-353">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-stretch" data-id="element-354">
          {/* Join CTA */}
          <div className="flex-1 rounded-2xl p-8 md:p-10 flex flex-col justify-between" style={{
          backgroundColor: '#c8a84b'
        }} data-id="element-355">
            <div data-id="element-356">
              <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{
              backgroundColor: 'rgba(30,61,47,0.15)'
            }} data-id="element-357">
                <UserPlusIcon size={24} style={{
                color: '#1e3d2f'
              }} data-id="element-358" />
              </div>
              <h2 className="text-3xl md:text-4xl font-bold uppercase mb-3" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1a1a1a'
            }} data-id="element-359">
                Join FLSC
              </h2>
              <p className="text-base leading-relaxed mb-6" style={{
              color: '#2a2a2a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-360">
                Become part of a community dedicated to safe, responsible
                shooting sports and outdoor recreation. Members enjoy 24/7 range
                access, discounted classes, and more.
              </p>
              <p className="text-sm font-medium mb-6" style={{
              color: '#2a2a2a',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-361">
                Click below to fill out an Application for Membership.
              </p>
            </div>
            <a href="/49.html" className="inline-flex items-center justify-center gap-2 w-full py-4 rounded-lg font-bold text-base transition-all hover:opacity-90 active:scale-95" style={{
            backgroundColor: '#1e3d2f',
            color: '#ffffff',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-362">
              <UserPlusIcon size={18} data-id="element-363" />
              Click Here to Apply
            </a>
          </div>

          {/* Member Login */}
          <div className="flex-1 rounded-2xl p-8 md:p-10" style={{
          backgroundColor: 'rgba(255,255,255,0.06)',
          border: '1px solid rgba(255,255,255,0.12)'
        }} data-id="element-364">
            <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{
            backgroundColor: 'rgba(200,168,75,0.15)'
          }} data-id="element-365">
              <LogInIcon size={24} style={{
              color: '#c8a84b'
            }} data-id="element-366" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold uppercase mb-3" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-367">
              Member Login
            </h2>
            <p className="text-sm mb-6" style={{
            color: '#a0b8a8',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-368">
              Your email address is your Login ID. Membership renewal is
              available when you edit your profile.
            </p>

            <form onSubmit={e => e.preventDefault()} className="space-y-4" aria-label="Member login form" data-id="element-369">
              <div data-id="element-370">
                <label htmlFor="member-email" className="block text-xs font-semibold uppercase tracking-wider mb-1.5" style={{
                color: '#a0b8a8',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-371">
                  Email Address
                </label>
                <div className="relative" data-id="element-372">
                  <MailIcon size={15} className="absolute left-3 top-1/2 -translate-y-1/2" style={{
                  color: '#7a9a8a'
                }} data-id="element-373" />
                  <input id="member-email" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="your@email.com" className="w-full pl-9 pr-4 py-3 rounded-lg text-sm outline-none transition-all" style={{
                  backgroundColor: 'rgba(255,255,255,0.08)',
                  border: '1px solid rgba(255,255,255,0.15)',
                  color: '#ffffff',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-374" />
                </div>
              </div>

              <div data-id="element-375">
                <label htmlFor="member-password" className="block text-xs font-semibold uppercase tracking-wider mb-1.5" style={{
                color: '#a0b8a8',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-376">
                  Password
                </label>
                <div className="relative" data-id="element-377">
                  <LockIcon size={15} className="absolute left-3 top-1/2 -translate-y-1/2" style={{
                  color: '#7a9a8a'
                }} data-id="element-378" />
                  <input id="member-password" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••" className="w-full pl-9 pr-4 py-3 rounded-lg text-sm outline-none transition-all" style={{
                  backgroundColor: 'rgba(255,255,255,0.08)',
                  border: '1px solid rgba(255,255,255,0.15)',
                  color: '#ffffff',
                  fontFamily: 'Inter, sans-serif'
                }} data-id="element-379" />
                </div>
              </div>

              <div className="flex gap-3 pt-1" data-id="element-380">
                <button type="submit" className="flex-1 flex items-center justify-center gap-2 py-3 rounded-lg font-semibold text-sm transition-all hover:opacity-90" style={{
                backgroundColor: '#c8a84b',
                color: '#1a1a1a',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-381">
                  <LogInIcon size={15} data-id="element-382" />
                  Log In
                </button>
                <button type="button" className="flex items-center justify-center gap-1.5 px-4 py-3 rounded-lg text-sm font-medium border transition-all hover:bg-white/10" style={{
                borderColor: 'rgba(255,255,255,0.2)',
                color: '#a0b8a8',
                fontFamily: 'Inter, sans-serif'
              }} data-id="element-383">
                  <KeyRoundIcon size={14} data-id="element-384" />
                  Find Pass
                </button>
              </div>
            </form>

            <div className="mt-5 flex items-start gap-2 p-3 rounded-lg" style={{
            backgroundColor: 'rgba(200,168,75,0.08)',
            border: '1px solid rgba(200,168,75,0.15)'
          }} data-id="element-385">
              <InfoIcon size={14} className="flex-shrink-0 mt-0.5" style={{
              color: '#c8a84b'
            }} data-id="element-386" />
              <p className="text-xs" style={{
              color: '#a0b8a8',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-387">
                You can opt out of email announcements in your membership
                profile. FLSC uses your profile email as our primary
                communication method.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}